import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md transition-all duration-300"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between items-center">
        <img 
          src="/logo-new.png" 
          alt="AP International Media Solutions - Zvanu centrs Latvijā" 
          className="h-8 md:h-10 object-contain cursor-pointer hover:opacity-80 transition-opacity duration-200"
          onClick={scrollToTop}
          loading="eager"
        />

        <nav className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('about')}
            className="text-gray-900 hover:text-gray-600 transition-colors duration-200"
          >
            {t.nav.about}
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="text-gray-900 hover:text-gray-600 transition-colors duration-200"
          >
            {t.nav.services}
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-gray-900 hover:text-gray-600 transition-colors duration-200"
          >
            {t.nav.contact}
          </button>

          <button
            onClick={toggleLanguage}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-black text-white hover:bg-gray-800 transition-all duration-200 hover:-translate-y-0.5"
          >
            <Globe size={18} />
            <span className="font-semibold">{language.toUpperCase()}</span>
          </button>
        </nav>

        {/* Mobile menu */}
        <button
          onClick={toggleLanguage}
          className="md:hidden flex items-center gap-2 px-3 py-2 rounded-lg bg-black text-white"
        >
          <Globe size={16} />
          <span className="font-semibold text-sm">{language.toUpperCase()}</span>
        </button>
      </div>
    </header>
  );
};

export default Header;